import React from 'react';
import { useTranslation } from 'react-i18next';
import PageHeader from '../shell/PageHeader';
import { useBreadcrumb } from '../../contexts/BreadcrumbContext';
import UnitReviewTable from './UnitReviewTable';

const UnitReviewPage: React.FC = () => {
  const { t } = useTranslation();
  useBreadcrumb([
    { label: 'Citrus Synch', to: '/' },
    { label: t('consumables.title'), to: '/consumables/catalog' },
    { label: t('consumables.unitReview.title') },
  ]);

  return (
    <div data-testid="consumables-unit-review-page">
      <PageHeader
        title={t('consumables.unitReview.title')}
        meta={t('consumables.unitReview.meta')}
      />
      <UnitReviewTable />
    </div>
  );
};

export default UnitReviewPage;
